import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import ReferenceLayersSidebar from '../../components/sidebars/ReferenceLayersSidebar';
import * as referenceLayerActions from '../../actions/referenceLayers';
import { checkLoggedInUserIsGlobalAdmin } from '../../actions/authentication/authCreators';
import HelpWrapper from '../../components/HelpWrapper';
import { getSetting } from '../../actions/settings/settingsCreators';
import { getVisibilityTypes } from '../../actions/referenceLayers';

class Industries extends React.Component {
  componentWillMount() {
    this.props.checkLoggedInUserIsGlobalAdmin();
  }

  componentDidMount() {
    const { getVisibilityTypes } = this.props;
    getVisibilityTypes();
  }

  handleSubmit = values => {
    if (values.id) {
      this.props.updateIndustry(values);
    }
  };

  componentWillReceiveProps(nextProps) {
    this.handleReferenceLayerIdUpdate(nextProps);
  }

  handleReferenceLayerIdUpdate = nextProps => {
    const currentReferenceLayerId = this.props.params.referenceLayerId;
    const newCurrentReferenceLayerId = nextProps.params.referenceLayerId;

    if (newCurrentReferenceLayerId !== currentReferenceLayerId) {
      this.props.updateCurrentReferenceLayer(
        parseInt(newCurrentReferenceLayerId, 10)
      );
    }
  };

  render() {
    const { settings } = this.props;
    return (
      <Grid fluid>
        <Helmet>
          <title>Manage Reference Layers | Campaign Targeter</title>
        </Helmet>
        <Row>
          <Col sm={3} className="sidebar-wrapper">
            <ReferenceLayersSidebar {...this.props} />
          </Col>
          <Col sm={9} className="industry-maincontent">
            <div>
              <Row>
                <HelpWrapper
                  pdfUrl={
                    settings && settings.industryHelpPdf
                      ? settings.industryHelpPdf.value
                      : undefined
                  }
                  videoUrl={
                    settings && settings.industryHelpVideo
                      ? settings.industryHelpVideo.value
                      : undefined
                  }
                  extraClass={this.props.children ? 'child-page-present' : ''}
                />
              </Row>
              {/* TODO: what goes in its place? */}
            </div>
            {this.props.children && (
              <Row className="industries-details">
                <Col sm={12}>
                  <div className="industries-maincontent industries-maincontent--ref-layers">
                    {React.cloneElement(this.props.children, { ...this.props })}
                  </div>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    referenceLayers: state.referenceLayers,
    currentOrganisation: state.currentOrganisation,
    currentReferenceLayer: state.currentReferenceLayer,
    visibilityTypes: state.visibilityTypes,
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...referenceLayerActions,
      checkLoggedInUserIsGlobalAdmin,
      getSetting,
      getVisibilityTypes
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Industries);



// WEBPACK FOOTER //
// ./src/containers/referenceLayers/ReferenceLayers.js